export { default } from './I18nextProvider';
export type { I18nextProviderProps } from './I18nextProvider';
